import { render, staticRenderFns } from "./catalog.cattle.io.clusterrepo.vue?vue&type=template&id=234ce4c3&"
import script from "./catalog.cattle.io.clusterrepo.vue?vue&type=script&lang=js&"
export * from "./catalog.cattle.io.clusterrepo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports